module.exports = __webpack_public_path__ + "img/ic-logo.70c26d9c.png";